<template>
  <el-container>
    <el-aside width="200px"></el-aside>
    <el-main>
      <el-card class="card">
        <template v-slot:header>
          <div class="clearfix">
            <span style="font-weight: bold;"><i class="el-icon-s-order" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Overlap Analysis Result</span>
            <el-button type="primary" icon="el-icon-download" size="medium" @click="exportCsv" style="float: right;background-color: #2C3E50;border: 1px solid #2C3E50;">Download</el-button>
          </div>
        </template>
        <div>
          <el-table :data="paginationData" border style="width:100%;color:black;" empty-text="No data available." fit>
            <el-table-column prop="bed1_region" label="Bed1_region"></el-table-column>
            <el-table-column prop="bed2_region" label="Bed2_region"></el-table-column>
            <el-table-column prop="overlap_rate" label="Overlap_rate"></el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 20px; text-align: center;"
            :current-page="currentPageRange"
            :page-size="pageSize"
            :total="tableData.length"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </el-card>
      <Overlapfig1 :overlapRegions="overlap_regions" />
      <Overlapfig2 :overlapRegions="overlap_regions" :nonOverlapRegions1="non_overlap_regions1" :nonOverlapRegions2="non_overlap_regions2"/>
    </el-main>
    <el-aside width="200px"></el-aside>
  </el-container>
</template>

<script>
import Overlapfig1 from './Overlapfig1.vue';
import Overlapfig2 from './Overlapfig2.vue';

export default {
  components:{
    Overlapfig1,
    Overlapfig2,
},
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      dataArray: [], // 定义并初始化一个空数组
      overlap_regions: [], // 添加 overlap_regions 数组
      non_overlap_regions1: [], // 添加 non_overlap_regions1 数组
      non_overlap_regions2: [], // 添加 non_overlap_regions2 数组
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.tableData.length / this.pageSize);
    },
    paginationData() {
      const start = (this.currentPageRange - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.tableData.slice(start, end);
    },
    currentPageRange() {
      return Math.max(1, Math.min(this.currentPage, this.pageCount));
    }
  },
  mounted() {
    const { overlap_regions } = this.$route.params.res;
    const { non_overlap_regions1 } = this.$route.params.res;
    const { non_overlap_regions2 } = this.$route.params.res;
    //传递重叠和非重叠数据，用来绘制韦恩图
    this.overlap_regions = overlap_regions; // 将重叠数据赋值给 overlap_regions 数组
    this.non_overlap_regions1 = non_overlap_regions1; // 将非重叠数据1赋值给 non_overlap_regions1 数组
    this.non_overlap_regions2 = non_overlap_regions2; // 将非重叠数据2赋值给 non_overlap_regions2 数组
    //提取其中的重叠数据，表格展示
    this.dataArray = [overlap_regions]; // 将对象的值提取出来，生成一个数组
    for (let i = 0; i < this.dataArray.length; i++) {
      const subArray = this.dataArray[i]; // 获取第 i 个子数组
      for (let j = 0; j < subArray.length; j++) {
        const [bed1_region, bed2_region, overlap_rate] = subArray[j]; // 解构第 j 个子数组中的数据
        const bed1_region_str = `${bed1_region[0]}: ${bed1_region[1]}-${bed1_region[2]}`;
        const bed2_region_str = `${bed2_region[0]}: ${bed2_region[1]}-${bed2_region[2]}`;
        // 构造行数据对象
        this.tableData.push({
          bed1_region: bed1_region_str,
          bed2_region: bed2_region_str,
          overlap_rate: overlap_rate
        });
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    exportCsv() {
      const header = ['Bed1_region', 'Bed2_region', 'Overlap_rate'];
      const data = this.tableData.map(row => ({
      Bed1_region: row.bed1_region,
      Bed2_region: row.bed2_region,
      Overlap_rate: row.overlap_rate
      }));
      const csv = [
      header.join(','),
      ...data.map(row => Object.values(row).join(','))
      ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'overlap_data.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>

<style>
.card {
  margin-top: 60px;
  margin-bottom: 30px;
  border-color: #010c0c;
}
.clearfix{
  font-size: larger;
}
</style>


// WEBPACK FOOTER //
// src/components/overlap/Overlaplist.vue